import React, { useState } from "react";
import { useAppText } from "src/commun/composants/AppText";
import { useFormikContext } from "formik";
import { VerificationMail } from "src/pages/finalisation/etapes/verificationMail/codeMailSend/useValidationSchemaMail";
import AppRow from "src/commun/composants/grille/AppRow";
import AppInput from "src/commun/composants/formulaire/AppInput/AppInput";
import AppInputFormik from "src/commun/composants/formulaire/formik/fields/AppInputFormik";
import { useAppState } from "src/app/state/StateProvider";
import { sendCodeMail } from "src/app/api/PublicApi";
import AppInputPasswordFormik from "src/commun/composants/formulaire/formik/fields/AppInputPasswordFormik";
import { AxiosError } from "axios";
import AppMessage from "src/commun/composants/AppMessage/AppMessage";

export type VerificationMailFormProps = {
  stepPrecedente: () => void;
  askForPassword?: boolean;
  setCustomError: (err: AxiosError | undefined) => void;
  displayCancelBtn?: boolean;
  cancelCallback?: () => void;
};

const CodeMailCheckFormContent = ({ stepPrecedente, askForPassword, setCustomError, displayCancelBtn, cancelCallback }: VerificationMailFormProps) => {
  const { tString } = useAppText();
  const { values, submitCount, submitForm} = useFormikContext<VerificationMail>();
  const [{ langue }] = useAppState();
  const [askNewCode, setAskNewCode] = useState(false);

  const handleSendCodeAgain = () => {
    sendCodeMail({email: values.email}, langue)
      .then(() => {
        setAskNewCode(true);
        setCustomError(undefined)
      })
      .catch(err => {
        setAskNewCode(false);
        setCustomError(err);
      });
  }

  return (
    <>
      {askNewCode &&
        <div className="mb-3">
          <AppMessage messageType="INFO" children={<>{tString("compte.mon.profile.email.code.renvoye")}</>} />
        </div>
      }
      <div className="input btn__filter--disabled">
        <AppInput name="mail" value={values.email} onChange={() => {}} disabled />
      </div>
      <div className="input mt-3 ">
        <AppInputFormik
          name="code"
          type="text"
          maxLength={35}
          iconVerif={false}
          formulaireSoumis={submitCount > 0}
        />
        <label>{tString("compte.mon.profile.email.code.recu")}</label>
      </div>
      <div className="mt-3 paragraph--gray">
        <p className="txt-underline cursor-pointer" onClick={handleSendCodeAgain}>{tString("compte.mon.profile.email.code.non.recu")}</p>
        <p>{tString("compte.mon.profile.email.code.non.recu.bloque")}</p>
      </div>

      {askForPassword &&
        <div className="mt-3">
          <p className={"important"}>{tString("update.email.password.message")}</p>
          <AppInputPasswordFormik
            name="password"
            label={tString("compte.mon.profile.password.nouveau.confirm")}
            formulaireSoumis={submitCount > 0}
          />
        </div>
      }

      <AppRow>
        <input
          className="btn__primary mt-3 btn--full--xs"
          type="submit"
          name="submit"
          onClick={submitForm}
          value={tString("action.verifier.code.validation")}
        />
      </AppRow>
      <AppRow>
        <input
          className="btn__primary mt-3 mr-3 btn--full--xs"
          type="submit"
          name="submit"
          onClick={stepPrecedente}
          value={tString("action.modifier.email")}
        />
        {displayCancelBtn &&
          <input
            className="btn__primary mt-3 btn--full--xs"
            type="submit"
            name="annuler"
            onClick={cancelCallback}
            value={tString("update.email.cancel.button")}
          />
        }
      </AppRow>
    </>
  );
};

export default CodeMailCheckFormContent;